module.exports = __webpack_public_path__ + "fonts/Aller_Rg.785388a9.ttf";